import { createReducer } from "../../../common/reduxUtil";
import { GMAT_SET_FEEDBACK, GMAT_SET_START_ERROR } from "./types";

const initialState = {
  isFeedbackOpen: false,
  startError: null,
};

export default createReducer(initialState, {
  [GMAT_SET_FEEDBACK]: (state, isFeedbackOpen) => ({
    ...state,
    isFeedbackOpen,
  }),
  [GMAT_SET_START_ERROR]: (state, startError) => ({ ...state, startError }),
});
